import styled from '@emotion/styled'

interface Props {
  underline?: boolean
}

export const LinkButton = styled.button<Props>`
  background: none;
  border: none;
  color: ${props => (props.disabled ? 'var(--White60)' : 'var(--Red-Dark)')};
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  text-decoration: ${props => (props.underline ? 'underline' : 'none')};
  display: inline-flex;
  align-items: center;
  &:hover {
    color: ${props => (props.disabled ? 'var(--White60)' : 'var(--Graphite)')};
    text-decoration: ${props => (props.underline ? 'none' : 'none')};
  }
`
